// The panel CTA's transient success text ("Seat held — added to cart").
// Moved from ServicePanel.tsx with zero behaviour change; `flashFeedback` is
// the setFeedback + timed clear pair every add path writes by hand.

import { useState } from "react";

export function useTransientFeedback() {
  const [feedback, setFeedback] = useState<string | null>(null);
  const flashFeedback = (message: string, ms = 2500) => {
    setFeedback(message);
    setTimeout(() => setFeedback(null), ms);
  };
  return { feedback, setFeedback, flashFeedback };
}
